import proyecto from "../../api/Proyecto";
import { getSelectedCajaId } from "../../helpers/cajaSelection";

export const registrarServicio = async ({ fecha, id_cliente = null, metodo_pago = "EFECTIVO", items = [], id_caja } = {}) => {
  const caja = id_caja ?? getSelectedCajaId();
  const response = await proyecto.post("/servicios-ventas", { fecha, id_cliente, metodo_pago, items, id_caja: caja });
  return response.data;
};
